import { FC } from "react"
import { BlankStateSection } from "src/components/shared/BlankStateSection"
import { CenteredSpinner } from "src/components/shared/CenteredSpinner"
import { IContact } from "src/domain/entities"
import { ContactListView } from "."

interface Props {
	list: IContact[]
	isLoading: boolean
	onUpdate: (contact: IContact) => void
	onDelete: (contact: IContact) => void
	onAddClick: () => void
}

export const ContactListController: FC<Props> = ({
	isLoading,
	list,
	onDelete,
	onUpdate,
	onAddClick,
}) => {
	if (isLoading) return <CenteredSpinner />

	if (list.length === 0) {
		return <BlankStateSection message="No contacts found." onAddClick={onAddClick} />
	}

	return <ContactListView list={list} onUpdate={onUpdate} onDelete={onDelete} />
}
